<template>
  <v-container>
    <Breadcrumbs :crumbs="crumbs" />
    <PageHeader>
      <template v-slot:header
        ><span style="margin-right: 50px">二次評価</span
        ><v-btn @click="downloadHalfPage()" text color="blue"
          >帳票空枠(半年分)</v-btn
        ><v-btn @click="downloadFullPage()" text color="blue"
          >帳票空枠(一年分)</v-btn
        ></template
      >
      <template v-slot:annotation
        >二次評価対象のスタッフ様の評価データを表示します。</template
      >
    </PageHeader>

    <div class="text-center px-3">
      <v-row>
        <v-col cols="12" md="4">
          <v-select
            label="期間（年度）"
            v-model="period"
            item-text="label"
            item-value="value"
            :items="periodItems"
            dense
            return-object
          />
        </v-col>
        <v-col v-if="isDepartmentActive" cols="12" md="4">
          <v-select
            label="部署"
            v-model="department"
            item-text="label"
            item-value="value"
            :items="departmentItems"
            dense
            return-object
          />
        </v-col>
        <v-col cols="12" md="4">
          <v-select
            label="優先順位"
            v-model="userRank"
            item-text="label"
            item-value="value"
            :items="userRankItems"
            dense
            return-object
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="4">
          <FormInputComponent
            label="氏名"
            v-model="userNameSearch"
            :length="10"
            :counter="10"
          />
        </v-col>
        <v-col cols="4" md="4" lg="2" class="text-left">
          <Button @click="get_evaluation()" color="primary">検索</Button>
        </v-col>
        <v-col cols="4" md="4" lg="2" v-if="isEvalEnd" class="text-left">
          <Button color="info" @click="eval_end_confirm">評価終了</Button>
        </v-col>
        <v-col cols="4" md="4" lg="2" v-if="isEvalSendBack" class="text-left">
          <Button color="info" @click="eval_send_back">評価修正</Button>
        </v-col>
      </v-row>

      <v-row>
        <v-col>
          <v-data-table
            :headers="headers"
            :items="items"
            :loading="loading"
            loading-text="読み込み中..."
            no-data-text="二次評価は見つかりませんでした。"
          >
            <template v-slot:[`item.USER_AVATER`]="{ item }">
              <Avatar
                v-if="item.USER_AVATER"
                :src="item.USER_AVATER"
                :size="40"
                class="mr-2"
              />
            </template>
            <template v-slot:[`item.BUTTON`]="{ item }">
              <Button
                color="secondary"
                class="mr-1"
                style="width: 50px"
                @click="onClickEvaluationView(item)"
                :small="true"
                >閲覧</Button
              >
              <Button
                color="secondary"
                class="mr-1"
                style="width: 50px"
                @click="print(item)"
                :small="true"
                >ダウンロード</Button
              >
              <Button
                v-if="
                  (item.SECOND_USER_ID == loginUserId ||
                    loginUserRank == 'sysop') &&
                  (item.EVAL_STATUS == '5' || item.EVAL_STATUS == '6') &&
                  isEvalConfirmActive
                "
                color="secondary"
                class="mr-1"
                style="width: 50px"
                @click="onClickSecondEvaluationDetail(item)"
                :small="true"
                >評価入力</Button
              >
              <Button
                v-if="
                  item.SECOND_USER_ID == loginUserId &&
                  item.EVAL_STATUS == '7' &&
                  isEvalConfirmActive
                "
                color="secondary"
                class="mr-1"
                style="width: 50px"
                @click="onClickSecondEvaluationDetailEdit(item)"
                :small="true"
                >評価修正</Button
              >
            </template>
          </v-data-table>
        </v-col>
      </v-row>
    </div>
    <EvaluationPrintDialog v-if="resetPrintFlag" ref="print" />
    <DialogMessage ref="dialog" />
    <ConfirmDialog
      ref="confirm"
      title="二次評価設定"
      :message="confirmMessage"
      buttonMessage="OK"
      @confirm="editStaffEvaluationSetting"
    />
    <DialogMessageAsync ref="asyncdialog" @confirm="asyncDialogBack">
    </DialogMessageAsync>
    <Loader :loading="loading" />
  </v-container>
</template>

<script>
import config from '@/const.js';
import axios from 'axios';
import message from '@/message.js';
import moment from 'moment';
import EvaluationPrintDialog from './EvaluationPrintDialog.vue';
import {
  getSessionStorageItem,
  convertEvaluationStatus,
  makeDateTimeStr,
  makeSystemDateStr,
} from '@/common.js';
import ConfirmDialog from '@/components/Common/ConfirmMessage.vue';
import DialogMessageAsync from '@/components/Common/DialogMessageAsync.vue';

export default {
  components: { EvaluationPrintDialog, ConfirmDialog, DialogMessageAsync },
  data() {
    return {
      crumbs: [
        {
          name: '二次評価',
          route: 'SecondEvaluation',
        },
      ],
      userInfo: {},
      loading: false,
      isDepartmentActive: true,
      isEvalConfirmActive: false,
      period: { value: '', label: '' },
      periodItems: [],
      periodItemsSearch: [],
      department: {},
      departmentItems: [],
      userRank: {},
      userRankItems: [],
      userNameSearch: '',
      loginUserId: '',
      loginUserRank: '',
      items: [],
      emptyHalfPdf: '',
      emptyFullPdf: '',
      headers: [
        {
          text: '期間(年度)名称',
          value: 'PERIOD_NAME',
          width: '15%',
        },
        {
          text: '氏名',
          align: 'left',
          value: 'USER_NAME',
          width: '15%',
        },
        {
          text: '部署',
          align: 'left',
          value: 'DEPARTMENT_NAME',
          width: '20%',
        },
        {
          text: '評価の状態',
          value: 'STATUS',
          width: '15%',
        },
        {
          text: '',
          value: 'BUTTON',
          width: '35%',
        },
      ],
      hasPeriod: false,
      initPeriodId: '',
      resetPrintFlag: false,
      isEvalEnd: false,
      isEvalSendBack: false,
      periodStatus: '',
      confirmMessage: '',
      selectPeriodId: '',
    };
  },
  created() {
    const userInfo = getSessionStorageItem();
    this.userInfo = userInfo;

    // ログインユーザーチェック
    this.checkLoginUser();

    if (userInfo) {
      this.userRank = userInfo.USER_RANK;
      this.loginUserRank = userInfo.USER_RANK;
      if (
        this.userRank == config.USER_RANK_TOP ||
        this.userRank == config.USER_RANK_M ||
        this.userRank == config.USER_RANK_SYSOP
      ) {
        // TopとMとシスオペの場合
        this.isDepartmentActive = true;
      } else {
        // 上記以外
        this.isDepartmentActive = false;
      }
    }
    // ログインユーザIDの設定
    this.loginUserId = this.userInfo.USER_ID;
    // 帳票空枠のパス設定
    this.emptyHalfPdf =
      config.S3_END_POINT + config.PRINT_DIRECTORY + config.PDF_NAME_HALF_YEAR;
    this.emptyFullPdf =
      config.S3_END_POINT + config.PRINT_DIRECTORY + config.PDF_NAME_ONE_YEAR;
    // 期間(年度)の設定
    this.getPeriod();
    // ユーザランク情報の設定
    this.get_userRank();
    // 部署情報の設定
    this.get_department();
    // 評価関連ボタン初期化
    this.isEvalEnd = false;
    this.isEvalSendBack = false;
  },

  methods: {
    asyncDialogBack() {
      // ログイン画面遷移処理
      this.$router.push({ name: 'Login' });
    },
    eval_end_confirm() {
      //----- 年度選択値チェック
      if (this.selectPeriodId != this.period.value) {
        // 選択した年度と検索時に使用した年度が異なる場合はエラー
        this.$refs.dialog.open(
          'info',
          '期間（年度）の選択値が検索したときと異なります。\n' +
            ' 再度、検索処理を実行するか、検索時の期間（年度）を選択してください。'
        );
        return;
      }
      this.loading = true;

      //----- 年度状態チェック
      axios
        .get(
          config.CONNECT_EVALUATIONS_URL +
            '/Evaluations/manages/period/primary/' +
            this.userInfo.SESSION_ID +
            '/' +
            this.userInfo.USER_ID +
            '/' +
            this.selectPeriodId
        )
        .then((response) => {
          // 年度データ取得
          if (response.data.length == 0) {
            // ローディング画像終了
            this.loading = false;

            // 現在の年度の状態が変更されていた場合は処理中断
            this.$refs.dialog.open(
              'info',
              '検索した評価年度のデータが他のスタッフ様によって削除されています。\n' +
                ' よって、評価終了処理を中断します。'
            );
            return;
          }
          let currentPeriodStatus = response.data[0].PERIOD_STATUS;
          if (currentPeriodStatus != this.periodStatus) {
            // ローディング画像終了
            this.loading = false;

            // 現在の年度の状態が変更されていた場合は処理中断
            this.$refs.dialog.open(
              'info',
              '評価年度の状態が他のスタッフ様によって更新されています。\n' +
                ' よって、評価終了処理を中断します。'
            );
            return;
          }

          //----- 目標作成状態チェック
          axios
            .get(
              config.CONNECT_EVALUATIONS_URL +
                '/Evaluations/manages/Organization/' +
                this.userInfo.SESSION_ID +
                '/' +
                this.userInfo.USER_ID +
                '/' +
                this.userInfo.ORGANIZATION_KEY
            )
            .then((response) => {
              let userMakeStatus = response.data[0].GOAL_MAKE_STATUS;
              if (userMakeStatus == config.EXEC_RUN) {
                // ローディング画像終了
                this.loading = false;

                // 1:実行中の場合は処理終了
                this.$refs.dialog.open(
                  'info',
                  '評価作成処理が実行中です。\n' +
                    ' しばらく時間が経過した後に実行をお願いします。'
                );
                return;
              } else {
                // 確認ダイアログ表示
                this.confirmMessage =
                  '【' +
                  this.period.label +
                  '】の評価を終了してよろしいですか？\n' +
                  '  ※評価終了すると以下の処理が実行されます。ご確認をお願いします。\n\n' +
                  '  ・該当の年度評価の状態が「完了」となります。\n' +
                  '  ・評価が終了したスタッフ様の集計表示一覧を閲覧することができます。';
                this.$refs.confirm.open();
                this.loading = false;
              }
            })
            .catch((error) => {
              // ローディング画像終了
              this.loading = false;

              let errStr = '';
              if (error.status == 400) {
                errStr = message.MSG_ERROR_SESSION_ERROR + error;
                this.$refs.dialog.open('error', errStr);
              } else {
                errStr = message.MSG_ERROR_SYTEM_ERROR + error;
                this.$refs.dialog.open('error', errStr);
              }
            });
        })
        .catch((error) => {
          // ローディング画像終了
          this.loading = false;

          let errStr = '';
          if (error.status == 400) {
            errStr = message.MSG_ERROR_SESSION_ERROR + error;
            this.$refs.dialog.open('error', errStr);
          } else {
            errStr = message.MSG_ERROR_SYTEM_ERROR + error;
            this.$refs.dialog.open('error', errStr);
          }
        });
    },
    eval_send_back() {
      //----- 年度選択値チェック
      if (this.selectPeriodId != this.period.value) {
        // 選択した年度と検索時に使用した年度が異なる場合はエラー
        this.$refs.dialog.open(
          'info',
          '期間（年度）の選択値が検索したときと異なります。\n' +
            ' 再度、検索処理を実行するか、検索時の期間（年度）を選択してください。'
        );
        return;
      }

      this.loading = true;
      //----- 年度状態チェック
      axios
        .get(
          config.CONNECT_EVALUATIONS_URL +
            '/Evaluations/manages/period/primary/' +
            this.userInfo.SESSION_ID +
            '/' +
            this.userInfo.USER_ID +
            '/' +
            this.selectPeriodId
        )
        .then((response) => {
          // 年度データ取得
          if (response.data.length == 0) {
            // ローディング画像終了
            this.loading = false;

            // 現在の年度の状態が変更されていた場合は処理中断
            this.$refs.dialog.open(
              'info',
              '検索した評価年度のデータが他のスタッフ様によって削除されています。\n' +
                ' よって、評価修正処理を中断します。'
            );
            return;
          }
          let currentPeriodStatus = response.data[0].PERIOD_STATUS;
          if (currentPeriodStatus != this.periodStatus) {
            // ローディング画像終了
            this.loading = false;

            // 現在の年度の状態が変更されていた場合は処理中断
            this.$refs.dialog.open(
              'info',
              '評価年度の状態が他のスタッフ様によって更新されています。\n' +
                ' よって、評価修正処理を中断します。'
            );
            return;
          }

          //----- 目標作成状態チェック
          axios
            .get(
              config.CONNECT_EVALUATIONS_URL +
                '/Evaluations/manages/Organization/' +
                this.userInfo.SESSION_ID +
                '/' +
                this.userInfo.USER_ID +
                '/' +
                this.userInfo.ORGANIZATION_KEY
            )
            .then((response) => {
              let userMakeStatus = response.data[0].GOAL_MAKE_STATUS;
              if (userMakeStatus == config.EXEC_RUN) {
                // ローディング画像終了
                this.loading = false;

                // 1:実行中の場合は処理終了
                this.$refs.dialog.open(
                  'info',
                  '評価作成処理が実行中です。\n' +
                    ' しばらく時間が経過した後に実行をお願いします。'
                );
                return;
              } else {
                axios
                  .get(
                    config.CONNECT_EVALUATIONS_URL +
                      '/Evaluations/manages/period/' +
                      this.userInfo.SESSION_ID +
                      '/' +
                      this.userInfo.USER_ID +
                      '/' +
                      this.userInfo.ORGANIZATION_KEY
                  )
                  .then((response) => {
                    this.loading = false;
                    // 年度データ取得
                    var isExistUnderEvaluation = false;
                    for (var i = 0; i < response.data.length; i++) {
                      if (
                        response.data[i].PERIOD_STATUS ==
                        config.PERIOD_STATUS_EVAL_DURING
                      ) {
                        // 評価中のデータあり
                        isExistUnderEvaluation = true;
                        break;
                      }
                    }
                    if (isExistUnderEvaluation) {
                      this.$refs.dialog.open(
                        'info',
                        '評価中の年度データが存在するため、評価中に戻すことができません。\n' +
                          ' 評価が完了後に、本年度の評価を評価中に戻してください。'
                      );
                      return;
                    } else {
                      // 確認ダイアログ表示
                      this.confirmMessage =
                        '【' +
                        this.period.label +
                        '】の年度を評価中に戻してよろしいですか？\n' +
                        '  ※評価修正すると以下の処理が実行されます。ご確認をお願いします。\n\n' +
                        '  ・該当の年度評価の状態が「評価中」となります。\n' +
                        '  ・評価が終了したスタッフ様の集計表示一覧を一時的に閲覧できなくなります。';
                      this.$refs.confirm.open();
                      this.loading = false;
                    }
                  })
                  .catch((error) => {
                    this.loading = false;
                    let errStr = '';
                    if (error.status == 400) {
                      errStr = message.MSG_ERROR_SESSION + error;
                      this.$refs.dialog.open('error', errStr);
                    } else {
                      errStr = message.MSG_ERROR_SYTEM + error;
                      this.$refs.dialog.open('error', errStr);
                    }
                  });
              }
            })
            .catch((error) => {
              // ローディング画像終了
              this.loading = false;

              let errStr = '';
              if (error.status == 400) {
                errStr = message.MSG_ERROR_SESSION_ERROR + error;
                this.$refs.dialog.open('error', errStr);
              } else {
                errStr = message.MSG_ERROR_SYTEM_ERROR + error;
                this.$refs.dialog.open('error', errStr);
              }
            });
        })
        .catch((error) => {
          // ローディング画像終了
          this.loading = false;

          let errStr = '';
          if (error.status == 400) {
            errStr = message.MSG_ERROR_SESSION_ERROR + error;
            this.$refs.dialog.open('error', errStr);
          } else {
            errStr = message.MSG_ERROR_SYTEM_ERROR + error;
            this.$refs.dialog.open('error', errStr);
          }
        });
    },
    editStaffEvaluationSetting() {
      // セッションチェック
      let userInfo = getSessionStorageItem();
      if (userInfo == null) {
        this.$refs.dialog.open(
          'error',
          message.MSG_ERROR_SESSION + message.MSG_ERROR_SESSION_DETAIL
        );
        this.loading = false;
        return;
      }
      if (this.isEvalEnd && !this.isEvalSendBack) {
        // 評価終了処理
        this.endEvaluationInfoRequest();
      } else if (!this.isEvalEnd && this.isEvalSendBack) {
        // 評価差戻処理
        this.sendBackEvaluationInfoRequest();
      }
    },
    endEvaluationInfoRequest() {
      // ローディング画像表示
      this.loading = true;
      // ユーザ情報の取得
      let userInfo = getSessionStorageItem();
      // 共通
      this.updateAt = moment().format('YYYYMMDDHHmmss');

      //----- 評価終了リクエストPOST
      axios
        .post(
          config.CONNECT_EVALUATIONS_URL + '/Evaluations/manages/period/end',
          {
            SESSION_ID: userInfo.SESSION_ID,
            SESSION_USER_ID: userInfo.USER_ID,

            ORGANIZATION_KEY: userInfo.ORGANIZATION_KEY,
            PERIOD_ID: this.period.value,
            PERIOD_STATUS: config.PERIOD_STATUS_EVAL_COMPLETE,
            UPDATED_AT: this.updateAt,
          }
        )
        .then((response) => {
          // ローディング画像終了
          this.loading = false;

          let msgStr = '';
          if (response.status == 200) {
            msgStr = '【' + this.period.label + '】の評価を終了しました。';
            this.$refs.dialog.open('info', msgStr);

            // 評価終了・修正ボタン制御
            this.isEvalEnd = false;
            this.isEvalSendBack = true;

            // 評価情報取得
            this.get_evaluation();
          }
        })
        .catch((error) => {
          // ローディング画像終了
          this.loading = false;

          let errStr = '';
          if (error.status == 400) {
            errStr = message.MSG_ERROR_SESSION_ERROR + error;
            this.$refs.dialog.open('error', errStr);
          } else {
            errStr = message.MSG_ERROR_SYTEM_ERROR + error;
            this.$refs.dialog.open('error', errStr);
          }
        });
    },
    sendBackEvaluationInfoRequest() {
      // ローディング画像表示
      this.loading = true;
      // ユーザ情報の取得
      let userInfo = getSessionStorageItem();
      // 共通
      this.updateAt = moment().format('YYYYMMDDHHmmss');

      //----- 評価差戻リクエストPOST
      axios
        .post(
          config.CONNECT_EVALUATIONS_URL +
            '/Evaluations/manages/period/sendback',
          {
            SESSION_ID: userInfo.SESSION_ID,
            SESSION_USER_ID: userInfo.USER_ID,

            ORGANIZATION_KEY: userInfo.ORGANIZATION_KEY,
            PERIOD_ID: this.period.value,
            PERIOD_STATUS: config.PERIOD_STATUS_EVAL_DURING,
            UPDATED_AT: this.updateAt,
          }
        )
        .then((response) => {
          // ローディング画像終了
          this.loading = false;

          let msgStr = '';
          if (response.status == 200) {
            msgStr =
              '【' +
              this.period.label +
              '】の評価を修正できる設定が完了しました。';
            this.$refs.dialog.open('info', msgStr);

            // 評価終了・修正ボタン制御
            this.isEvalEnd = true;
            this.isEvalSendBack = false;

            // 評価情報取得
            this.get_evaluation();
          }
        })
        .catch((error) => {
          // ローディング画像終了
          this.loading = false;

          let errStr = '';
          if (error.status == 400) {
            errStr = message.MSG_ERROR_SESSION_ERROR + error;
            this.$refs.dialog.open('error', errStr);
          } else {
            errStr = message.MSG_ERROR_SYTEM_ERROR + error;
            this.$refs.dialog.open('error', errStr);
          }
        });
    },
    async checkLoginUser() {
      // ローディング画像表示
      this.loading = true;

      await axios
        .get(
          config.CONNECT_EVALUATIONS_URL +
            '/Evaluations/manages/login/user/' +
            this.userInfo.SESSION_ID +
            '/' +
            this.userInfo.USER_ID
        )
        .then((response) => {
          // 評価データ取得
          if (response.status == 200) {
            if (response.data[0].USER_RANK != this.userInfo.USER_RANK) {
              var msgStr =
                'Hitonobiを操作しているスタッフ様の等級が変更されています。\n' +
                ' 操作で不具合が発生する可能性があるため、Hitonobiをログアウトします。';
              this.$refs.asyncdialog.open('info', msgStr);
              return;
            }
          }
        })
        .catch((error) => {
          let errStr = '';
          if (error.response.status == 400) {
            errStr = message.MSG_ERROR_SESSION + error;
            this.$refs.dialog.open('error', errStr);
          } else {
            errStr = message.MSG_ERROR_SYTEM + error;
            this.$refs.dialog.open('error', errStr);
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    downloadHalfPage() {
      window.open(this.emptyHalfPdf, '_blank');
    },
    downloadFullPage() {
      window.open(this.emptyFullPdf, '_blank');
    },
    print(item) {
      this.$refs.print.open(
        item.GOAL_ID,
        item.USER_ID,
        this.period.value,
        item.EVAL_NUM,
        item.PERIOD_NAME
      );
    },
    onClickSecondEvaluationDetail(item) {
      this.$router.push({
        name: 'SecondEvaluationDetail',
        params: {
          goalId: Buffer.from(item.GOAL_ID).toString('base64'),
          userId: Buffer.from(item.USER_ID).toString('base64'),
          entryKind: config.ENTRY_KIND_ENTRY,
        },
      });
    },
    onClickSecondEvaluationDetailEdit(item) {
      this.$router.push({
        name: 'SecondEvaluationDetail',
        params: {
          goalId: Buffer.from(item.GOAL_ID).toString('base64'),
          userId: Buffer.from(item.USER_ID).toString('base64'),
          entryKind: config.ENTRY_KIND_UPDATE,
        },
      });
    },
    onClickEvaluationView(item) {
      this.$router.push({
        name: 'EvaluationView',
        params: {
          goalId: Buffer.from(item.GOAL_ID).toString('base64'),
          userId: Buffer.from(item.USER_ID).toString('base64'),
          periodId: Buffer.from(this.period.value).toString('base64'),
          evalKind: config.EVAL_KIND_SECOND,
        },
      });
    },
    async get_evaluation() {
      // ユーザ情報取得
      let userInfo = getSessionStorageItem();

      // 印刷コンポーネントの初期化
      this.resetPrintFlag = false;

      // セッションチェック
      if (userInfo == null) {
        this.$refs.dialog.open(
          'error',
          message.MSG_ERROR_SESSION + message.MSG_ERROR_SESSION_DETAIL
        );
        return;
      }

      // 期間(年度)チェック
      if (!this.period.value) {
        this.$refs.dialog.open(
          'info',
          '期間(年度)が選択されていません。期間(年度)は必須選択です。'
        );
        return;
      }
      // 年度ID
      var periodId = this.period.value;
      // 部署
      if (this.isDepartmentActive) {
        var departmentKey = this.department.value;
        if (!departmentKey) {
          departmentKey = config.EMPTY_STRING;
        }
      } else {
        departmentKey = userInfo.DEPARTMENT_KEY;
      }

      // ユーザランク
      var userRank = this.userRank.value;
      if (!userRank) {
        userRank = config.EMPTY_STRING;
      }
      // 氏名
      var userName = this.userNameSearch;
      if (!userName) {
        userName = config.EMPTY_STRING;
      }
      // ログインユーザランク
      var loginUserRannk = userInfo.USER_RANK;
      if (userInfo.USER_RANK == config.USER_RANK_SYSOP) {
        // シスオペでログインした場合、TOP権限で検索
        loginUserRannk = config.USER_RANK_TOP;
      }

      let vm = this;
      this.loading = true;

      axios
        .get(
          config.CONNECT_EVALUATIONS_URL +
            '/Evaluations/manages/period/primary/' +
            this.userInfo.SESSION_ID +
            '/' +
            this.userInfo.USER_ID +
            '/' +
            this.period.value
        )
        .then((response) => {
          // 年度データ取得
          this.periodStatus = response.data[0].PERIOD_STATUS;

          //----- 評価開始ボタン表示制御
          this.isEvalEnd = false;
          this.isEvalSendBack = false;
          if (response.data.length > 0) {
            if (
              this.userInfo.USER_RANK == config.USER_RANK_TOP ||
              this.userInfo.USER_RANK == config.USER_RANK_SYSOP
            ) {
              // ログインユーザーがTOPとシスオペの場合、各ボタン表示
              if (this.periodStatus == config.PERIOD_STATUS_EVAL_DURING) {
                // 2:評価中
                this.isEvalEnd = true;
              } else if (
                this.periodStatus == config.PERIOD_STATUS_EVAL_COMPLETE
              ) {
                // 3:評価完了
                this.isEvalSendBack = true;
              }
              // 評価修正データ表示制御
              if (
                response.data[0].PERIOD_STATUS ==
                config.PERIOD_STATUS_EVAL_COMPLETE
              ) {
                // 評価完了の場合、非表示
                this.isEvalConfirmActive = false;
              } else {
                // 上記以外、表示
                this.isEvalConfirmActive = true;
              }
            }
          }

          axios
            .get(
              config.CONNECT_EVALUATIONS_URL +
                '/Evaluations/second/evaluation/' +
                userInfo.SESSION_ID +
                '/' +
                userInfo.USER_ID +
                '/' +
                periodId +
                '/' +
                departmentKey +
                '/' +
                userRank +
                '/' +
                userName +
                '/' +
                loginUserRannk
            )
            .then((response) => {
              // スタッフデータ取得
              vm.items = response.data;
              for (var i = 0; i < vm.items.length; i++) {
                // 状態
                vm.items[i].STATUS = convertEvaluationStatus(
                  vm.items[i].EVAL_STATUS
                );
              }
              // 検索時に使用した年度を退避
              this.selectPeriodId = this.period.value;
            })
            .catch((error) => {
              let errStr = '';
              if (error.status == 400) {
                errStr = message.MSG_ERROR_SESSION + error;
                this.$refs.dialog.open('error', errStr);
              } else {
                errStr = message.MSG_ERROR_SYTEM + error;
                this.$refs.dialog.open('error', errStr);
              }
            })
            .finally(() => {
              // 印刷コンポーネントの再描画
              this.resetPrintFlag = true;
              // ローディング画像終了
              this.loading = false;
            });
        })
        .catch((error) => {
          let errStr = '';
          if (error.status == 400) {
            errStr = message.MSG_ERROR_SESSION + error;
            this.$refs.dialog.open('error', errStr);
            return;
          } else {
            errStr = message.MSG_ERROR_SYTEM + error;
            this.$refs.dialog.open('error', errStr);
            return;
          }
        });
    },
    async get_department() {
      // 部署情報取得
      this.loading = true;
      let vm = this;

      await axios
        .get(
          config.CONNECT_URL +
            '/Encouragements/manage/department/' +
            this.userInfo.SESSION_ID +
            '/' +
            this.userInfo.USER_ID +
            '/' +
            this.userInfo.ORGANIZATION_KEY
        )
        .then((response) => {
          // 部署データ取得
          this.departmentItems = [];
          var emptyItem = { label: '', value: '' };
          this.departmentItems.push(emptyItem);
          vm.tmpItems = response.data;
          for (let i = 0; i < vm.tmpItems.length; i++) {
            var item = {
              label: vm.tmpItems[i].DEPARTMENT_NAME,
              value: vm.tmpItems[i].DEPARTMENT_KEY,
            };
            this.departmentItems.push(item);
          }
        })
        .catch((error) => {
          let errStr = '';
          if (error.status == 400) {
            errStr = message.MSG_ERROR_SESSION + error;
            this.$refs.dialog.open('error', errStr);
          } else {
            errStr = message.MSG_ERROR_SYTEM + error;
            this.$refs.dialog.open('error', errStr);
          }
        });
      // ローディング画像終了
      this.loading = false;
    },
    async get_userRank() {
      // ローディング画像表示
      this.loading = true;

      var emptyItem = { label: '', value: '' };
      this.userRankItems.push(emptyItem);

      if (
        this.userRank == config.USER_RANK_TOP ||
        this.userRank == config.USER_RANK_SYSOP
      ) {
        // M
        var itemM = {
          label: this.userInfo.USER_RANK_NAME_2,
          value: config.USER_RANK_M,
        };
        this.userRankItems.push(itemM);
        // S
        var itemS = {
          label: this.userInfo.USER_RANK_NAME_3,
          value: config.USER_RANK_S,
        };
        this.userRankItems.push(itemS);
        // J
        var itemJ = {
          label: this.userInfo.USER_RANK_NAME_4,
          value: config.USER_RANK_J,
        };
        this.userRankItems.push(itemJ);
        // E
        var itemE = {
          label: this.userInfo.USER_RANK_NAME_5,
          value: config.USER_RANK_E,
        };
        this.userRankItems.push(itemE);
      } else if (this.userRank == config.USER_RANK_M) {
        // S
        var itemS_M = {
          label: this.userInfo.USER_RANK_NAME_3,
          value: config.USER_RANK_S,
        };
        this.userRankItems.push(itemS_M);
        // J
        var itemJ_M = {
          label: this.userInfo.USER_RANK_NAME_4,
          value: config.USER_RANK_J,
        };
        this.userRankItems.push(itemJ_M);
        // E
        var itemE_M = {
          label: this.userInfo.USER_RANK_NAME_5,
          value: config.USER_RANK_E,
        };
        this.userRankItems.push(itemE_M);
      } else if (this.userRank == config.USER_RANK_S) {
        // J
        var itemJ_S = {
          label: this.userInfo.USER_RANK_NAME_4,
          value: config.USER_RANK_J,
        };
        this.userRankItems.push(itemJ_S);
        // E
        var itemE_S = {
          label: this.userInfo.USER_RANK_NAME_5,
          value: config.USER_RANK_E,
        };
        this.userRankItems.push(itemE_S);
      } else if (this.userRank == config.USER_RANK_J) {
        // E
        var itemE_J = {
          label: this.userInfo.USER_RANK_NAME_5,
          value: config.USER_RANK_E,
        };
        this.userRankItems.push(itemE_J);
      }

      // ローディング画像終了
      this.loading = false;
    },
    async getPeriod() {
      this.loading = true;
      let vm = this;
      await axios
        .get(
          config.CONNECT_EVALUATIONS_URL +
            '/Evaluations/manages/period/' +
            this.userInfo.SESSION_ID +
            '/' +
            this.userInfo.USER_ID +
            '/' +
            this.userInfo.ORGANIZATION_KEY
        )
        .then((response) => {
          // 年度データ取得
          vm.tmpItems = response.data;
          var nowStr = makeSystemDateStr();
          this.hasPeriod = false;
          this.initPeriodId = '';

          for (var i = 0; i < vm.tmpItems.length; i++) {
            var periodStartDate = makeDateTimeStr(
              'S',
              vm.tmpItems[i].PERIOD_START_DATE
            );
            var periodEndDate = makeDateTimeStr(
              'E',
              vm.tmpItems[i].PERIOD_END_DATE
            );
            // 現在日時が年度開始・終了の期間内かを判定
            if (periodStartDate <= nowStr && periodEndDate >= nowStr) {
              //this.hasPeriod = true;
              this.initPeriodId = vm.tmpItems[i].PERIOD_ID;
            }

            var item = {
              label: vm.tmpItems[i].PERIOD_NAME,
              value: vm.tmpItems[i].PERIOD_ID,
            };
            this.periodItems.push(item);
            var itemSearch = {
              PERIOD_ID: vm.tmpItems[i].PERIOD_ID,
              PERIOD_STATUS: vm.tmpItems[i].PERIOD_STATUS,
            };
            this.periodItemsSearch.push(itemSearch);
          }
          // ラベル設定
          for (var j = 0; j < vm.tmpItems.length; j++) {
            if (vm.tmpItems[j].PERIOD_ID == this.initPeriodId) {
              this.period.label = vm.tmpItems[j].PERIOD_NAME;
            }
          }

          this.period.value = this.initPeriodId;
        })
        .catch((error) => {
          let errStr = '';
          if (error.status == 400) {
            errStr = message.MSG_ERROR_SESSION + error;
            this.$refs.dialog.open('error', errStr);
          } else {
            errStr = message.MSG_ERROR_SYTEM + error;
            this.$refs.dialog.open('error', errStr);
          }
        });

      this.loading = false;
    },
  },
};
</script>
<style>
.pageout {
  position: fixed;
  top: 200vh;
}
</style>
